import React from 'react';
import { Button, Result } from 'antd';

/**
 * Fallback component shown when an error boundary catches an error.
 * Replaces aplanet-ui-kit's ErrorBoundaryFallback.
 *
 * Props:
 *  - titleErrorMessage       (string) Title text
 *  - descriptionErrorMessage (string) Description text
 *  - buttonLabel             (string) Reload button label
 *  - customErrorImage        (string) Image URL (optional)
 */
const ErrorBoundaryFallback = ({
  titleErrorMessage,
  descriptionErrorMessage,
  buttonLabel,
  customErrorImage,
}) => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh', padding: 24 }}>
      <Result
        icon={customErrorImage ? <img src={customErrorImage} alt="error" style={{ maxWidth: 200 }} /> : undefined}
        status={customErrorImage ? undefined : 'error'}
        title={titleErrorMessage}
        subTitle={descriptionErrorMessage}
        extra={
          buttonLabel ? (
            <Button type="primary" onClick={handleReload}>
              {buttonLabel}
            </Button>
          ) : null
        }
      />
    </div>
  );
};

export default ErrorBoundaryFallback;
